module.exports = __webpack_public_path__ + "static/media/stp_card_amex.45482995.png";